@if (basket.itemsCount() === 0) {
  <div class="basket__empty">
    <mat-icon class="basket__empty-icon">shopping_cart</mat-icon>
    <p class="basket__empty-text">Din kurv er tom</p>
    <ng-content select="[basketEmptyCta]" />
  </div>
} @else {
  <div class="basket__items">
    @for (item of basket.combinedItems(); track item.id) {
      <app-basket-item [item]="item" />
    }
  </div>

  @if (basket.hasRepeatablePattern()) {
    <div class="basket__repeatable-hint">
      <mat-icon class="basket__repeatable-hint-icon">repeat</mat-icon>
      <span>Vi har set et mønster — prøv "Gentag periode" fra menuen på en af tiderne</span>
    </div>
  }

  <div class="basket__footer">
    @if (basket.totalPrice() > 0) {
      <div class="basket__total">
        <span>Total</span>
        <span class="basket__total-amount">{{ basket.totalPrice() }} kr.</span>
      </div>
    }
    <abook-button icon="arrow_forward" size="medium" [isLoading]="isCheckingOut()" (clicked)="goToCheckout()">
      Gå til betaling
    </abook-button>
    <abook-button appearance="text" size="small" (clicked)="basket.clearBasket()">
      Tøm kurv
    </abook-button>
    @if (checkoutError()) {
      <div class="basket__checkout-error" role="alert">{{ checkoutError() }}</div>
    }
  </div>
}
